import type { Error, Validator } from '../types';

export const composeValidatorsWithThreshold =
  (validators: Validator[], message?: Error['message'], threshold?: number) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (value: any): Error => ({
    valid:
      validators.reduce(
        (passed, validator) => ((validator(value) as Error).valid ? ++passed : passed),
        0
      ) >= (threshold || validators.length),
    message
  });
